import type { PostHog } from 'posthog-js'

function getPlatform(): 'ios' | 'android' | 'web' {
  const ua = navigator.userAgent
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  if (/Android/i.test(ua)) return 'android'
  return 'web'
}

export function captureEndUserRedirect(
  posthog: PostHog | undefined,
  params: { userId?: string; entryPoint: 'login' | 'changePassword' },
) {
  posthog?.capture('portal_end_user_redirect', {
    userId: params.userId,
    entryPoint: params.entryPoint,
    referrer: document.referrer,
    entryUrl: window.location.href,
    platform: getPlatform(),
    skPlatform: 'portal',
  })
}
